module.exports = __webpack_public_path__ + "static/media/en-data-roaming-iphone_1.c2b2cd4a.png";